export const GET_OFFER_AGGREGATE_BY_USER_ID = (id: number) => `/offer/aggregate/${id}`;
